module.exports = ".disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n    filter: alpha(opacity=60);\n    border: 1px solid #999999;\n    background-color: #cccccc;\n  }\n\n\n\n  button:disabled,\nbutton[disabled]{\n  border: 1px solid #999999 !important;\n  background-color: blanchedalmond !important;\n  color: #666666;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/broker/transfer-employer-close-office/select-employees/select-employees.component.css
// module id = ./src/app/broker/transfer-employer-close-office/select-employees/select-employees.component.css
// module chunks = main